module.exports = __webpack_public_path__ + "static/media/avc_pluse.bc2900e2.svg";